const obj_2_arr = (o, kid, enm) => {

	let a = []

	Object.keys(o).forEach( (k, i) => { 
						enm && (o[k][enm]=i); 
						kid && (o[k][kid]=k); 
						a.push( o[k] );
					} )

	return a
}

export default obj_2_arr